export const JOB_OPTIONS = [
  { value: "fields", label: "Fields it" },
  { value: "cover_1b", label: "Covers 1B" },
  { value: "cover_2b", label: "Covers 2B" },
  { value: "cover_3b", label: "Covers 3B" },
  { value: "cover_home", label: "Covers home" },
  { value: "cutoff", label: "Cutoff" },
  { value: "relay", label: "Relay" },
  { value: "backup", label: "Backs up" },
  { value: "hold", label: "Holds" },
];

export const JOB_LABEL = Object.fromEntries(JOB_OPTIONS.map((j) => [j.value, j.label]));

export const COVER_BASE = { cover_1b: "first", cover_2b: "second", cover_3b: "third", cover_home: "home" };

export const POSITIONS = ["P", "C", "1B", "2B", "SS", "3B", "LF", "CF", "RF"];

export const BASE_NAMES = { home: "Home", first: "1st", second: "2nd", third: "3rd" };

export const RUNNER_TEXT = {
  0: "Bases empty", 1: "Runner on 1st", 2: "Runner on 2nd", 4: "Runner on 3rd",
  3: "1st & 2nd", 5: "1st & 3rd", 6: "2nd & 3rd", 7: "Bases loaded",
};

export const HIT_TEXT = { ground: "Ground", fly: "Fly", bunt: "Bunt" };
